import { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { EXTRA_TYPES } from './constants';
import styles from './ImagePlanTag.module.scss';
import outlineStyles from './index.module.scss';

// 普通大纲里的配图标签：长描述折叠为一行摘要，可展开查看完整描述（完整描述始终保留在大纲数据中）
export default function ImagePlanTag({ description, fallbackName = '' }) {
    const [expanded, setExpanded] = useState(false);
    const descriptionId = useId();
    const text = typeof description === 'string' ? description : '';
    const compactText = text.trim();
    const hasDetails = compactText.length > 64 || /[|｜\r\n；;]/u.test(compactText);
    const config = EXTRA_TYPES.image;

    if (!hasDetails) {
        const name = fallbackName || compactText;
        return (
            <div
                className={`${outlineStyles.extraTagItem} ${styles.compact}`}
                style={{ '--tag-color': config.color }}
            >
                <span className={outlineStyles.extraTagIcon}>{config.icon}</span>
                <span className={outlineStyles.extraTagLabel}>{config.label}</span>
                {name && <span className={outlineStyles.extraTagDesc}>：{name}</span>}
            </div>
        );
    }

    const firstPart = compactText
        .split(/[|｜\r\n；;。]/u)[0]
        .replace(/^(?:图名|图题)\s*[:：]\s*/u, '')
        .trim();
    const title = firstPart || fallbackName || '配图方案';
    const titleChars = Array.from(title);
    const summary = titleChars.length > 48 ? `${titleChars.slice(0, 48).join('')}…` : title;

    return (
        <div className={styles.plan}>
            <div className={styles.header}>
                <span className={styles.kind}>
                    {config.icon}
                    {config.label}
                </span>
                <span className={styles.title}>{summary}</span>
                <button
                    type="button"
                    className={styles.toggle}
                    aria-expanded={expanded}
                    aria-controls={descriptionId}
                    onClick={(event) => {
                        event.stopPropagation();
                        setExpanded((value) => !value);
                    }}
                >
                    {expanded ? '收起描述' : '查看描述'}
                    <ChevronDown
                        size={14}
                        aria-hidden
                        className={expanded ? styles.flipped : undefined}
                    />
                </button>
            </div>
            <div
                id={descriptionId}
                className={styles.description}
                role="region"
                aria-label="完整配图描述"
                hidden={!expanded}
            >
                {text}
            </div>
        </div>
    );
}
